var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErc20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6431 22.8286C5.56763 22.8286 0.643066 17.9041 0.643066 11.8286C0.643066 5.75318 5.56763 0.828613 11.6431 0.828613C17.7185 0.828613 22.6431 5.75318 22.6431 11.8286C22.6431 17.9041 17.7185 22.8286 11.6431 22.8286ZM17.1389 11.9792L11.9854 3.57861L6.83057 11.9799L11.9854 14.9726L17.1389 11.9792ZM17.1431 12.9396L11.9854 15.9309L6.83057 12.9403L11.9854 20.0752L17.1431 12.9396Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9854 3.57861V9.67674L17.1395 11.9799L11.9854 3.57861ZM11.9854 15.9316V20.0752L17.143 12.9396L11.9854 15.9316Z",
    fill: "black",
    fillOpacity: 0.298
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9854 14.9727L17.1395 11.98L11.9854 9.67822V14.9727Z",
    fill: "black",
    fillOpacity: 0.801
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83057 11.98L11.9854 14.9727V9.67822L6.83057 11.98Z",
    fill: "black",
    fillOpacity: 0.298
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErc20);
export default __webpack_public_path__ + "static/media/erc20.e5df4cd66ac24e2444a4c0f1a37ab342.svg";
export { ForwardRef as ReactComponent };